<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <!-- Link al manuale del referente aziendale -->
    <b-card class="mt-3" no-body>
      <p class="mb-0 pb-1 pt-1 pl-2">
        Scarica il manuale d'uso:
        <b-link id="manuale_cr_azi" href="https://userportal.welfarebit.it/media/docs/manuale_cruscotto_aziendale_rev01.pdf" target="_blank">
          <b><i>Manuale Cruscotto Aziendale</i></b>
        </b-link>
      </p>
    </b-card>

    <!-- Menu referente, gli viene passata la configurazione base della pagina -->
    <!-- la quale sarà renderizzata secondo i permessi dell'utente          -->
    <HomeMenu :menu_struct="menu_struct" :customer_styles="customer_styles">

      <!-- === PULSANTI PER AZIONI GENERALI: ===  -->
      <!-- Popoliamo lo slot nella card prima del menù con due pulsanti:        -->
      <!-- * apertura form hubspot per richiesta nuova convenzione              -->
      <!-- * visualizzazione dei fornitori che offrono i servizi all'azienda    -->
      <!-- I PULSANTI SONO VISUALIZZATI SOLO SE CI TROVIAMO NELLA PRIMA SEZIONE -->
      <!-- TODO: Per fare una cosa fatta bene dovremmo proprio toglierlo da qui.-->
      <template v-slot:section-menu-before="slotProps">
        <b-row v-if="slotProps.section_content.section_title == 'Referente Aziendale - Servizi'">
          <b-col>
            <b-button variant="primary" size="sm" class="mr-1 mb-2"
                      href="https://lp.welfarebit.it/it-it/lp_fornitori_convenzioni_ondemand"
                      target="_blank">
              <font-awesome-icon icon="plus" class="mr-2"/>Richiedi nuova convenzione
            </b-button>
            <b-button variant="primary" size="sm" class="ml-1 mb-2" @click="forn_modal.show_modal = true">
              <font-awesome-icon icon="handshake" class="mr-2"/>Fornitori convenzionati
            </b-button>
          </b-col>
        </b-row>
      </template>

    </HomeMenu>

    <!-- === MODALE PER VISUALIZZARE I FORNITORI CHE OFFRONO I SERVIZI ALL'AZIENDA === -->
    <b-modal scrollable
             no-close-on-esc
             no-close-on-backdrop
             size="lg"
             v-model="forn_modal.show_modal"
             @show="on_forn_modal_show"
             title="Elenco aziende.">
      <!-- Corpo della modale -->
      <template v-slot:default>
        <h6>Di seguito la lista delle aziende convenzionate:</h6>
        <b-overlay :show="forn_modal.show_overlay" spinner-variant="primary">
          <b-table-simple hover responsive>
            <b-thead>
              <b-tr>
                <b-th>Nome</b-th>
                <b-th>Località</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(item, index) in forn_modal.table_items" :key="index">
                <b-td>{{item.nome}}</b-td>
                <b-td>{{item.localita}}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-overlay>
      </template>
      <!-- Footer ( lo rimapiazziamo per mettere solo il pulsante chiudi ) -->
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()" variant="primary">Chiudi</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import HomeMenu from '@/components/home_components/HomeMenu.vue'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import { customerStylesMixin } from '@/mixins/customerStylesMixin'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'HomeRefAziendale',
  mixins: [ customerStylesMixin ],
  data () {
    return {

      menu_struct : [
        {
          section_title : 'Referente Aziendale - Dashboard Gestione',
          section_menu  : [
            { title : 'Situazione Attuale',           image : require('@/assets/menu_badges/badge_refazi_situazione_att.jpg'),        route_name : 'office-transactionsdash' },
            { title : 'Scadenzario Aziendale',        image : require('@/assets/menu_badges/badge_refazi_scadenzario_az.jpg'),        route_name : 'office-scadenzario-azi' },
            { title : 'Messaggistica Interna',        image : require('@/assets/menu_badges/badge_refazi_mess_interna.jpg'),          route_name : 'office-mess-interna' },
            { title : 'Gestione Files',               image : require('@/assets/menu_badges/badge_miei_files.jpg'),                   route_name : 'office-user-files' },
            { title : 'Delega Consulenza',            image : require('@/assets/menu_badges/badge_delega_consulenza.jpg'),            route_name : 'office-consulenti' },
            { title : 'Genera Chiavi di Cifratura',   image : require('@/assets/menu_badges/badge_chiavi_cifratura.jpg'),             route_name : 'office-cifratura-chain' },
            { title : 'Import Caricamento Tracciato', image : require('@/assets/menu_badges/badge_import_caricamento_tracciato.jpg'), route_name : 'office-import-anagrafiche-crediti' },
            { title : 'Piani welfare',                image : require('@/assets/menu_badges/menuPianiWelfare.jpg'),                   route_name : 'office-ref-azi-piani-welfare'},
            { title : 'Dashboard PIC',                image : require('@/assets/menu_badges/badge_dashboard_pic.jpg'),                route_name : 'office-PICdash' },
            { title : 'Gestione dipendenti',          image : require('@/assets/menu_badges/badge_gestione_dipendenti.jpg'),          route_name : 'office-gestione-dipendenti' },
            { title : 'Conversione Premio',           image : require('@/assets/menu_badges/badge_conversione_premio.jpg'),           route_name : 'office-conversione-premio' },
          ]
        },
        {
          section_title : 'Referente Aziendale - Servizi',
          section_menu  : [
            { title : 'Loyalty & Incentive - Scopri Cos\'è',      image : require('@/assets/menu_badges/badge_incentive_info.jpg'),               route_name : 'office-incentive-info' },
            { title : 'Loyalty & Incentive - Acquista i Crediti', image : require('@/assets/menu_badges/badge_incentive_toduba.jpg'),             route_name : 'office-incentive-toduba' },
            { title:  'Buoni Pasto',                              image:  require('@/assets/menu_badges/WelfarebitPoweredTodoba.jpg'),            route_name:  'office-ref-azi-buoni-pasto'},
            { title : 'Piattapasto',                              image : require('@/assets/menu_badges/badge_refazi_piattapasto.jpg'),           route_name : 'office-piattapasto' },
          ]
        }
      ],

      // Elementi per la modale con l'elenco delle aziende fornitrici
      forn_modal : {
        show_modal : false,
        table_items : [],
        show_overlay : false
      }

    }
  },
  methods: {
    /**
     * Quando si apre la modale dei fornitori convenzionati popola l'array
     * degli elementi prendendo la lista dal backend.
     */
    on_forn_modal_show : function () {

      // Pulisco prima l'array
      this.forn_modal.table_items = new Array();

      this.forn_modal.show_overlay = true;

      axios.get( apiUrl.fornitoriapi.get_fornitori_disponibili )
      .then( ( response ) => {

        // Ciclo sugli elementi e creo un oggetto con le sole chiavi
        // "nome" e "localita"
        for ( let elem of response.data ) {
          this.forn_modal.table_items.push({
            nome : elem.nome + " " + elem.cognome,
            localita : elem.comune + " (" + elem.provincia + ")"
          });
        }

        // Metto in ordine alfabetico
        this.forn_modal.table_items.sort( (a,b) => { return (a.nome > b.nome) ? 1 : ( (b.nome > a.nome) ? -1 : 0 ) } );

        // Tolgo lo spinner
        this.forn_modal.show_overlay = false;

      })
      .catch( ( error ) => {
        this.forn_modal.show_overlay = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  components: {
    HomeMenu,
    SwitcherAziende
  }
}
</script>


<style scoped>
  #manuale_cr_azi {
    text-decoration: none;
  }
</style>
